function initWatermelonWidget() {
  let attempts = 0;

  const interval = setInterval(() => {
    attempts += 1;

    const widget = document.querySelector('watermelon-widget-button');

    if (!widget) {
      if (attempts > 100) clearInterval(interval); // ~10 секунд
      return;
    }

    clearInterval(interval);

    widget.style.setProperty(
      '--watermelon-yg-widget-button-background',
      '#fce221'
    );

    const widgetBtn = widget.shadowRoot.querySelector(
      '.watermelon-widget-button'
    );

    document.querySelectorAll('[data-open-chat]').forEach(button =>
      button.addEventListener('click', () => {
        widgetBtn.click();
      })
    );
  }, 100);
}

document.addEventListener('DOMContentLoaded', initWatermelonWidget);
